/* eslint-disable */

import './analytics/rawAnalytics';
import { HelpCrunchService} from '../services/HelpCrunchService';


export const trackEvent = (action, label, options={}) => {
  if (!window.gtag) {
    return;
  }

  const nonInteraction = Boolean(options.nonInteraction);

  window.gtag('event', action, {
    'event_category': 'Click',
    'event_label': label,
    'value': { 'nonInteraction': nonInteraction },
  });

  const data = { cta_type: label };

  window.fbq && window.fbq('track', action, data);
};

export const trackAmplitudeEvent = (action, options= {}) =>{
  window.amplitude && window.amplitude.getInstance().logEvent(action, options);
};

export function setGlobalSiteTagCustomData(name, value) {
  if (window.gtag) {
    window.gtag('set', { [name]: value });
  }
}

export function setAnalyticsUserData(user) {
  const {
    email,
    name,
    id,
    created_at,
    studio = { id: '' },
    subscription = { name: '', trial: false, interval: '' },
  } = user;

  const helpCrunchUser = {
    email: email,
    name: name,
    user_id: id,
    custom_data: {
      plan_name: subscription.name,
      signup_date: created_at,
      trial: Boolean(subscription.trial).toString(),
      studio_id: studio.id,
      interval: subscription.interval,
    },
  };

  HelpCrunchService.setUser(helpCrunchUser);
  setGlobalSiteTagCustomData('user_id', user.id);
}

export function initOrtto(user) {
  const { name: first = '', email = '' } = user;
  if (window.ap3c) {
    window.ap3c?.track({
      email,
      v: 0,
      first,
      last: '',
    });
  }
}

export default trackEvent;
